module.exports = __webpack_public_path__ + "img/Error404.33200f5d.svg";